// @core/api/endpoints/task/delete_task_category.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/task';

/**
 * Delete task category
 * Deletes a task category. Tasks in this category retain their current value.
 */
export async function DeleteTaskCategory(
  category_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/task-categories/:category_id`;
  requestPath = requestPath.replace(':category_id', encodeURIComponent(category_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
